
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useExperienciaDocente = () => {

    // variables
    const setToast = useEmpleadoStore( state => state.setToast )
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const expDocenteInicial = {
        funcion: 'guardarExp',
        tipo: 'docente',
        inicio: '',
        final: '',
        puesto: '',
        empresa: '',
        correo: objLogueado.email
    }
    const { URL } = url()
    const [isOpen, setIsOpen] = useState( false )
    const [expDocente, setExpDocente] = useState([])
    const [formExpDocente, setformExpDocente] = useState( expDocenteInicial )
    const [pkExp, setPkExp] = useState( 0 )
    const [cargando, setCargando] = useState( false )
	const [valorAnterior, setValorAnterior] = useState({inicio: '', final: ''})



    // funciones
    const traerExpDocente = () => {

        var fd = new FormData()
        fd.append("funcion", "traerExp")
        fd.append("tipo", "docente")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setExpDocente( e )
        })
        .catch( a => {
            setToast( true )
        })

    }


    const guardarExp = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formExpDocente, pkExp })
        })
        .then( res => res.json() )
        .then( function (d) {
            traerExpDocente()
            alert( d.mensaje )
            if ( d.codigo === 1 ) {
                setformExpDocente( expDocenteInicial )
                cerrarModal()
            }
        })
        .catch( a => {
            alert("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.")
        })
        .finally( () => setCargando( false ) )
    }

    const abrirModal = ( borrar_pk = true ) => {
        setIsOpen( true )
        if ( borrar_pk ) {
            setPkExp( 0 )
        }
    }

    const cerrarModal = () => {
        setIsOpen( false )
        setformExpDocente( expDocenteInicial )
    }

    function borrarExp( pk_exp ) {
        if ( pk_exp && window.confirm("El registro será eliminado.") ) {
            fetch( URL, {
                method: 'post',
                body: JSON.stringify({ pk_exp: pk_exp, funcion: 'borrarExp' })
            })
            .then( res => res.json() )
            .then( function (d) {
                if ( d.codigo === 1 ) {
                    traerExpDocente()
                    elToast( 'Eliminado con éxito' )
                } else {
                    elToast( d.mensaje, 'info' )
                }
            })
            .catch( a => {
                alert("Error al eliminar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.")
            })
        }
    }

    function llenarFormExpDocente( e ) {
        setformExpDocente({
            funcion: 'guardarExp',
            tipo: 'docente',
            inicio: e.inicio,
            final: e.final,
            puesto: e.puesto,
            empresa: e.empresa,
            correo: objLogueado.email
        })
		setValorAnterior({inicio: e.inicio, final: e.final})
        setPkExp( e.pk_exp )
        abrirModal( false )
    }


    // useEffects
    useEffect(() => {
        traerExpDocente()
        // eslint-disable-next-line
    }, [])


    return {
        isOpen, abrirModal, cerrarModal,
        guardarExp, setformExpDocente, formExpDocente,
        traerExpDocente, expDocente,
        llenarFormExpDocente, cargando, borrarExp, pkExp,
		valorAnterior
    }
}

export default useExperienciaDocente
